import {
  MODERATOR_QUESTIONARE,
  MODERATOR_QUESTIONARE_ANSWER,
  MODERATOR_QUESTIONARE_CATEGORY,
} from "../mock/URLs";
import {
  GetVoteQuestionCategoryResponse,
  GetVoteQuestionsResponse,
  GetVoteRequestByIdResponse,
  GetVoteRequestsResponse,
} from "../types/voteQuestions";
import { api } from "./api";

export const getVoteQuestionCategory = async ({ params }) => {
  try {
    const { data } = await api.get<GetVoteQuestionCategoryResponse>(
      MODERATOR_QUESTIONARE_CATEGORY,
      {
        params,
      }
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const getVoteQuestionCategoryById = async (categoryId) => {
  try {
    const { data } = await api.get(
      `${MODERATOR_QUESTIONARE_CATEGORY}${categoryId}/`
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const createVoteQuestion = async (values: FormData) => {
  try {
    const { data } = await api.post(MODERATOR_QUESTIONARE_CATEGORY, values);
    return data;
  } catch (e) {
    throw e;
  }
};

export const updateVoteQuestion = async (id: number | string, values) => {
  try {
    const { data } = await api.patch(
      `${MODERATOR_QUESTIONARE_CATEGORY}${id}/`,
      values
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const getVoteQuestionsByCategoryId = async ({ params }) => {
  try {
    const { data } = await api.get<GetVoteQuestionsResponse>(
      MODERATOR_QUESTIONARE,
      {
        params,
      }
    );
    return data;
  } catch (e) {
    throw e;
  }
};

// question
export const updateVoteQuestionItem = async (id: number | string, values) => {
  try {
    const { data } = await api.patch(
      `${MODERATOR_QUESTIONARE_CATEGORY}${id}/`,
      values
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const createVoteQuestionItem = async (values) => {
  try {
    const { data } = await api.post(MODERATOR_QUESTIONARE, values);
    return data;
  } catch (e) {
    throw e;
  }
};

// tushgan murojaatlar
export const getVoteRequests = async ({ params }) => {
  try {
    const { data } = await api.get<GetVoteRequestsResponse>(
      MODERATOR_QUESTIONARE_ANSWER,
      {
        params,
      }
    );
    return data;
  } catch (e) {
    throw e;
  }
};

export const getVoteRequestById = async (requestId) => {
  try {
    const { data } = await api.get<GetVoteRequestByIdResponse>(
      `${MODERATOR_QUESTIONARE_ANSWER}${requestId}/`
    );
    return data;
  } catch (e) {
    throw e;
  }
};
